import { render, staticRenderFns } from "./EditBasicSection.vue?vue&type=template&id=22eee2c8"
import script from "./EditBasicSection.vue?vue&type=script&lang=js"
export * from "./EditBasicSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports